import {
  FILTER_ENDOFDAY_REPORT,
  ENDOFDAY_REPORT_RES,
  FILTER_APPOINTMENTLIST_REPORT,
  FILTER_APPOINTMENTLIST_REPORT_RES,
  FILTER_COLLECTION_REPORT,
  FILTER_COLLECTION_REPORT_RES,
  ALL_USERS,
  ALL_USERS_RES,
  PRIOR_REPORT,
  PRIOR_REPORT_RES,
  CLEAR_CLAIM_LEVEL_RESPONSE,
  FILTER_SELF_REPORT,
  SELF_PAY_PATIENT_REPORT_REQUEST,
  SELF_PAY_PATIENT_REPORT_SUCCESS,
  SELF_PAY_PATIENT_EXPORT_REQUEST,
  SELF_PAY_PATIENT_EXPORT_SUCCESS,
  CLEAR_SELF_PAY_EXPORT,
  SELF_PAY_PATIENT_REQUEST_CLAIM,
  SELF_PAY_PATIENT_REQUEST_CPT,
  CLEAR_SELF_PAY_CLAIM,
  SELF_PAY_PATIENT_SUCCESS_CLAIM,
  SELF_PAY_PATIENT_SUCCESS_CPT,
  CLEAR_SELF_PAY_CPT,
  PREVISIT_ESTIMATE_REPORT_REQUEST,
  PREVISIT_ESTIMATE_REPORT_SUCCESS,
  PREVISIT_ESTIMATE_EXPORT_REQUEST,
  PREVISIT_ESTIMATE_EXPORT_SUCCESS,
  CLEAR_PREVISIT_ESTIMATE_EXPORT,
  PREVISIT_ESTIMATE_DOWNLOAD_REQUEST,
  PREVISIT_ESTIMATE_DOWNLOAD_SUCCESS,
  CLEAR_PREVISIT_ESTIMATE_DOWNLOAD,
} from './reports.types'


export const filteRendOfDayReport = (params) => ({
  type: FILTER_ENDOFDAY_REPORT,
  payload: params,
})

export const endOfDayReportResponse = (response) => ({
  type: ENDOFDAY_REPORT_RES,
  payload: response,
})

export const filterAppointmentList = (params) => ({
  type: FILTER_APPOINTMENTLIST_REPORT,
  payload: params,
})

export const filterAppointmentListRes = (response) => ({
  type: FILTER_APPOINTMENTLIST_REPORT_RES,
  payload: response,
})
export const filterCollection = (params) => ({
  type: FILTER_COLLECTION_REPORT,
  payload: params,
})

export const filterCollectionRes = (response) => ({
  type: FILTER_COLLECTION_REPORT_RES,
  payload: response,
})

export const allUsers = (params) => ({
  type: ALL_USERS,
  payload: params,
})

export const allUsersRes = (response) => ({
  type: ALL_USERS_RES,
  payload: response,
})

export const priorReport = (response) => ({
  type: PRIOR_REPORT,
  payload: response
})

export const priorReportRes = (response) => ({
  type: PRIOR_REPORT_RES,
  payload: response
})

export const filterSelfReport = (response) => ({
  type: FILTER_SELF_REPORT,
  payload: response
})

export const getSelfPayPatientRequest = (clinicId) => ({
  type: SELF_PAY_PATIENT_REPORT_REQUEST,
  payload: clinicId,
})

export const getSelfPayPatientSuccess = (data) => ({
  type: SELF_PAY_PATIENT_REPORT_SUCCESS,
  payload: data,
})

export const getSelfPayExportRequest = (clinicId) =>({
  type: SELF_PAY_PATIENT_EXPORT_REQUEST,
  payload: clinicId,
})

export const getSelfPayExportSuccess = (data) => ({
  type : SELF_PAY_PATIENT_EXPORT_SUCCESS,
  payload: data,
})

export const clearSelfPayExport = () => ({
  type: CLEAR_SELF_PAY_EXPORT,
  payload: null,
})

export const selfPayPatientClaimRequest = (data) => ({
  type: SELF_PAY_PATIENT_REQUEST_CLAIM,
  payload: data,
})

export const selfPayPatientClaimSuccess = (data) => ({
  type: SELF_PAY_PATIENT_SUCCESS_CLAIM,
  payload: data,
})

export const selfPayPatientCPTRequest = (data) => ({
  type: SELF_PAY_PATIENT_REQUEST_CPT,
  payload: data,
})

export const selfPayPatientCPTSuccess = (data) => ({
  type: SELF_PAY_PATIENT_SUCCESS_CPT,
  payload: data,
})

export const clearSelfPayClaim =() =>({
  type : CLEAR_SELF_PAY_CLAIM,
  payload: null
})

export const clearSelfPayCPT = () => ({
  type: CLEAR_SELF_PAY_CPT,
  payload:null,
})

export const getPrevisitEstimateRequest = (data) => ({
  type: PREVISIT_ESTIMATE_REPORT_REQUEST,
  payload: data,
})

export const getPrevisitEstimateSuccess = (data) => ({
  type: PREVISIT_ESTIMATE_REPORT_SUCCESS,
  payload: data,
})

export const getPrevisitEstimateExportRequest = (data) => ({
  type: PREVISIT_ESTIMATE_EXPORT_REQUEST,
  payload: data,
})

export const getPrevisitEstimateExportSuccess = (data) => ({
  type: PREVISIT_ESTIMATE_EXPORT_SUCCESS,
  payload: data,
})

export const clearPrevisitEstimateExport = () => ({
  type: CLEAR_PREVISIT_ESTIMATE_EXPORT,
  payload: null,
})

export const getPrevisitEstimateDownloadRequest = (filePath) => ({
  type: PREVISIT_ESTIMATE_DOWNLOAD_REQUEST,
  payload: filePath,
})

export const getPrevisitEstimateDownloadSuccess = (data) => ({
  type: PREVISIT_ESTIMATE_DOWNLOAD_SUCCESS,
  payload: data,
})

export const clearPrevisitEstimateDownload = () => ({
  type: CLEAR_PREVISIT_ESTIMATE_DOWNLOAD,
  payload: null,
})